/* istanbul ignore file */
import { ArrivalService } from './ArrivalService';

export class ArrivalServerService implements ArrivalService {
  trackArrival() {}
}
